import { Expander, Notification } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import {
  ContentSection,
  MarketingDetailsExpanderContent,
  PreferredLanguageDropDown,
  SideImageContainerContent,
} from '../../components'
import { ResponsiveHeadline } from '../../components/typography/ResponsiveHeadline'
import { StoreContext } from '../../store'

const SettingsViewComponent: React.FC = () => {
  const { t } = useTranslation()
  const { userStore, infoStore } = useContext(StoreContext)

  return (
    <SideImageContainerContent>
      <ResponsiveHeadline as="h1">{t(`sideMenu.mySettings`)}</ResponsiveHeadline>
      <ContentSection>
        {t('detailsView.settingsGeneral')}
        {infoStore.isPartialConsumer && (
          <Notification dismissible={false} contentType="warning">
            {t('detailsView.partialContent')}
          </Notification>
        )}
        {userStore.error && (
          <StyledNotification
            contentType={userStore.error === 'marketingSuccess' ? 'success' : 'alert'}
            dismissible={false}
          >
            {getErrorText(userStore.error, t) || ''}
          </StyledNotification>
        )}
        <PreferredLanguageDropDown />
      </ContentSection>
      <MarketingDetailsExpanderContent />
    </SideImageContainerContent>
  )
}

export const SettingsView = observer(SettingsViewComponent)

const getErrorText = (error: string, t: (string: string) => any): string | undefined => {
  if (error === 'failedToUpdateLanguage') {
    return t(`detailsView.langError`)
  } else if (error === 'marketingChanges') {
    return t(`detailsView.marketingError`)
  } else if (error === 'marketingSuccess') {
    return t(`detailsView.marketingSuccess`)
  } else {
    return undefined
  }
}

const StyledNotification = styled(Notification)`
  margin-top: 24px;
`

export const BrandExpander = styled(Expander)(
  () => css`
    button {
      outline: none;
    }
  `
)
